import React, { useState, useEffect, useRef, useMemo, use } from "react";
import { Box, Typography, IconButton, Dialog } from "@mui/material";
import {
  LuRefreshCw,
  FiFileText,
  LuChevronDown,
  LuCopy,
  LuFileMinus,
  LuPlus,
  LuArrowLeft,
} from "@/Components/Icons/Icons";
import { BlackButton } from "@/Components/Buttons/FiledButton";
import { navurl } from "@/Config/Routeconfig/NavigationUrl";
import { OutLinedButton } from "@/Components/Buttons/OutLinedButton";
import { Menu, MenuItem } from "@mui/material";
import { getAllNamesFromMultipleSchemas } from "@/Utils/CsvColumns";
import { useNavigate, useParams } from "react-router-dom";
import { useUser } from "@/Context/UserContext";
import { SectionHeader } from "@/Components/Header/SectionsHeader";
import { hookMap } from "@/redux/hookMap";
import { BiSolidError } from "react-icons/bi";
import { iconMap } from "@/redux/iconMap";
import { TabWithIndependentButtons } from "@/Components/Tabs/SubTabs";
import { useLazyGetExportGeneralByIdQuery } from "@/redux/ExportPage/Dashboard/ExportIdSlice";
import { useInvoice } from "@/Context/InvoiceContext";
import CreateFilterBox from "@/Views/ExportJob/CreateNewJob/CreateFilterBox";
import FormGenerator from "@/Utils/FormGenerator/FormGenerator";
import SuccessDialog from "@/Components/Dialog/SuccessDialog";
import CreateNewJobSidebarItems from "@/Config/Export/CreateNewJob/CreateNewjobsidebar";
import TableGenerator from "@/Utils/FormGenerator/TableGenerator";
import CustomTabs from "@/Components/Tabs/CustomTab";
import TableWithFieldGenerator from "@/Utils/FormGenerator/TableWithFieldGenerator";
import FormDialog from "@/Components/Dialog/FormDialog";
import CheckboxBox from "@/Components/Form/CheckboxBox";
import dayjs from "dayjs";
import Papa from "papaparse";
import CreateJobLayout from "@/Views/ExportJob/CreateNewJob/CreateNewJobLayout";
import schema1 from "@/Config/Export/CreateNewJob/GeneralDetailsSchema";
import schema2 from "@/Config/Export/CreateNewJob/Entity/EntityCustomizedList";
import { dynamicComponentMap } from "@/Utils/DynamicComponents";
import { LuCheck } from "react-icons/lu";
import { applyDynamicRules } from "@/Utils/Rules/ApplyConditions";
import { defaultValues } from "@/Constant/Common/Common";
import { eximCodeTabMap } from "@/Constant/Common/Common";
import { tabToEximCodeMap } from "@/Constant/Common/Common";
import { useLazyGetDocumentByTemplateQuery } from "../../../redux/ExportPage/CreateNewJob/Documents";
// import {LuAlertTriangle} from "react-icons";
// import { generateRowsFromDropdown } from "../../../Utils/Rules/tableAutoFill";
import Declaration from "../../../Views/ExportJob/CreateNewJob/Declaration";
import { useGetEximCodeQuery } from "@/redux/Masters/Masters";
import { schemaMap } from "@/Utils/SchemaMap";
import ConfirmDialog from "@/Components/Dialog/ConfirmDialog";

const CreateNewJob = () => {
  const formRef = useRef();
  const dynamicTrackingRef = useRef({});

  const [activeIndex, setActiveIndex] = useState(0);
  const [activeSubIndex, setActiveSubIndex] = useState(0);
  const [activeNestedIndex, setActiveNestedIndex] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [triggerGetDocument] = useLazyGetDocumentByTemplateQuery();
  const clearAll = useUser((s) => s.clearAll);
  const isRequiredFieldFilled = useUser((s) => s.isRequiredFieldFilled);
  const setIsRequiredFieldFilled = useUser((s) => s.setIsRequiredFieldFilled);
  const loading = useUser((s) => s.loading);
  const [openDeclaration, setOpenDeclaration] = useState(false);
  const setLoading = useUser((s) => s.setLoading);
  const formData = useUser((s) => s.formData);
  const setEximData = useUser((s) => s.setEximData);
  const setFormData = useUser((s) => s.setFormData);
  const setIsDataFetched = useUser((s) => s.setIsDataFetched);
  const exporterMasterId = useUser((s) => s.exporterMasterId);
  const setExporterMasterId = useUser((s) => s.setExporterMasterId);
  // {openDeclaration && <Declaration onClose={() => setOpenDeclaration(false)} />}

  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [successDialogConfig, setSuccessDialogConfig] = useState(null);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [subDialogConfig, setSubDialogConfig] = useState(false);
  const [subDialogOpen, setSubDialogOpen] = useState(false);

  const [formDialogData, setFormDialogData] = useState({});
  const [schema, setSchema] = useState({});
  const [saveLoading, setSaveLoading] = useState(false);
  const [dialogOwnerConfig, setDialogOwnerConfig] = useState(null);
  const { exporterId } = useParams();
  const [disableCopy, setDisableCopy] = useState(false);
  const [sidebarItems, setSidebarItems] = useState([]);
  const [openComponent, setOpenComponent] = useState(null);
  const [trigger, setTrigger] = useState(0);
  const [processingId, setProcessingId] = useState(null);
  const [extraApi, setExtraApi] = useState(null);
  const [tablecompKey, setTableCompkey] = useState(null);
  const [subTabs, setSubTabs] = useState();
  const { data: eximData = [], isLoading: eximLoading } = useGetEximCodeQuery();
  const isEditMode = Boolean(exporterId);
  const isActivation = Boolean(formData?.general?.exporterJobNumber);
  const [activeTableId, setActiveTableId] = useState(null);
  const [confirmationConfig, setConfirmationConfig] = useState(null);
  useEffect(() => {
    clearAll();
  }, []);
  useEffect(() => {
    setExporterMasterId(exporterId);
  }, [exporterId]);

  // ✅ Get initial items from hook
  // Generate the static initial sidebar
  const initialItems = useMemo(
    () => CreateNewJobSidebarItems(formData, eximData),
    [formData, eximData]
  );

  // 1️⃣ Flatten all APIs from nested sidebar items
  const collectApiKeys = (items) => {
    let keys = [];
    items.forEach((item) => {
      if (item.api) keys.push(item.api);
      if (item.tableApi) keys.push(item.tableApi);
      Object.keys(item)
        .filter((key) => key.startsWith("tableApi"))
        .forEach((key) => {
          keys.push(item[key]);
        });

      if (item.extraApi) keys.push(item.extraApi);
      if (item.subTabs) keys.push(...collectApiKeys(item.subTabs));
    });
    return keys;
  };

  // 2️⃣ Custom hook to call all API hooks safely
  const useSidebarApiHooks = (items) => {
    const allKeys = Array.from(new Set(collectApiKeys(items))); // unique
    const results = allKeys.map((key) => {
      const hook = hookMap[key];
      return hook ? hook() : null; // ✅ called unconditionally
    });
    return allKeys.reduce((acc, key, i) => {
      acc[key] = results[i];
      return acc;
    }, {});
  };

  const apiHooks = useSidebarApiHooks(initialItems);

  // Update sidebar items dynamically when formData changes
  useEffect(() => {
    const updatedItems = applyDynamicRules(initialItems, formData);
    setSidebarItems(updatedItems);

    const currentItem = updatedItems[activeIndex];
    if (currentItem?.disabled) {
      const firstEnabledIndex = updatedItems.findIndex(
        (item) => !item.disabled
      );
      if (firstEnabledIndex !== -1) setActiveIndex(firstEnabledIndex);
    }
  }, [formData]);

  const openForm = (
    schema,
    label,
    id,
    ownerConfig = null,
    extraApi = null,
    compkey = null
  ) => {
    setFormDialogData({});
    setIsEditing(false);
    setShowForm(true);
    setExtraApi(extraApi);
    setSchema({ schema, label });
    setActiveTableId(id);
    // setTableCompkey(compkey);
    if (ownerConfig) {
      setDialogOwnerConfig(ownerConfig);
    }
  };

  const jsonSchemaColumns = getAllNamesFromMultipleSchemas([schema1, schema2]);

  const navigate = useNavigate();

  const fileInputRef = useRef();

  const handleImportClick = () => {
    // localStorage.removeItem("exporterMasterId");
    navigate("/export/job", { replace: true });
    setTimeout(() => {
      fileInputRef.current.click();
    }, 100);
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const csvData = results.data;

        // Base object with all schema columns empty
        const baseObject = {};
        jsonSchemaColumns.forEach((col) => {
          baseObject[col] = "";
        });

        // Merge CSV row values into base object
        const mappedData = csvData.map((row) => {
          const newRow = { ...baseObject };
          jsonSchemaColumns.forEach((col) => {
            if (row[col] !== undefined) newRow[col] = row[col];
          });
          return newRow;
        });

        // Form ku first row
        const finalData = mappedData[0] || baseObject;
        setFormData(finalData);

        // Table ku all rows + index
        const tableWithIndex = mappedData.map((row, idx) => ({
          id: idx + 1,
          ...row,
        }));
        setTableData(tableWithIndex);
      },
      error: (err) => console.error("CSV parse error:", err),
    });
  };

  const goToCreateNewJob = async () => {
    try {
      // Step 1: Show loader
      setLoading(true);

      // Step 2: Clear data
      await new Promise((resolve) => {
        clearAll({});
        setTimeout(resolve, 800); // small delay to let context clear
      });

      // Step 3: Set states
      setIsDataFetched(true);
      setDisableCopy(true);

      // Step 4: Navigate
      navigate("/export/job");
    } catch (err) {
      console.error("Error while creating new job:", err);
    } finally {
      // Step 5: Hide loader
      setLoading(false);
    }
  };

  const copyJobData = () => {
    navigate("/export/job");
  };

  const confirmDelete = async (row, tableKey) => {
    try {
      setConfirmationConfig((prev) => ({ ...prev, loading: true }));

      await handleDelete({ id: row.id }, tableKey);

      setConfirmationConfig((prev) => ({
        ...prev,
        open: false,
        loading: false,
      }));
      // setDeleteTarget(null);
    } catch (err) {
      console.error("Delete failed:", err);

      setConfirmationConfig((prev) => ({ ...prev, loading: false }));
    }
  };

  const handleCloseForm = () => {
    setIsEditing(false);
    setFormDialogData({});
    setShowForm(false);
    setSubDialogOpen(false);
    setDialogOwnerConfig(null);
  };

  const handlers = {
    handleEdit: (row) => {
      if (!row) return;
      const currentSchema = schemaMap[row?.__schemaKey];
      const { tableKey } = resolveTableIdConditionally(
        row,
        currentTab,
        currentTab.id
      );


      setActiveTableId(tableKey);
      setFormDialogData(row);
      setIsEditing(true);
      setShowForm(true);

      setSchema({ schema: currentSchema ?? currentTab.schema });
    },
    handleRemove: async (row) => {
      try {
        const { tableKey } = resolveTableIdConditionally(
          row,
          currentTab,
          currentTab.id
        );

        setConfirmationConfig({
          open: true,
          label: "Delete Confirmation",
          title: "Are you sure you want to delete this item?",
          subtitle: "",
          confirmLabel: "Delete",
          cancelLabel: "Cancel",
          loading: false,
          onConfirm: () => confirmDelete(row, tableKey), // dynamic callback
          loadingText: "Deleting...",
        });
      } catch (err) {
        console.error("Failed to delete:", err);
      }
    },
    handleRowClick: async (row) => {
      try {
        await handleRowSelect({ id: row.id }, row);
      } catch (err) {
        console.error("Failed to select the row:", err);
      }
    },
    handleView: (row) => {
      if (!row) return;
      const fileObjectKey = Object.keys(row).find(
        (key) =>
          row[key] &&
          typeof row[key] === "object" &&
          row[key].filePath &&
          row[key].fileName
      );

      if (fileObjectKey) {
        const fileData = row[fileObjectKey];
        try {
          const fileUrl = `${import.meta.env.VITE_BASE_FILE_URL}${fileData.filePath}`;
          window.open(encodeURI(fileUrl), "_blank");
        } catch (err) {
          console.error("View failed:", err);
        }
        return;
      }
    },
  };

  const [fetchExportGeneral, { data, isFetching }] =
    useLazyGetExportGeneralByIdQuery();

  const handlerefresh = async (id = exporterMasterId) => {
    try {
      setLoading(true);
      const result = await fetchExportGeneral({
        id: id,
      }).unwrap();

      if (!result) return;
      setFormData((prev) => ({
        ...prev,
        ["general"]: {
          ...(prev["general"] || {}),
          ...result,
        },
      }));
      setIsRequiredFieldFilled(true);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setSaveLoading(false);
      setIsDataFetched(true);
    }
  };

  const documentOptions = [
    "Shipping Bill",
    "Shipping Bill (GST)",
    "Annexure",
    "Invoice",
    "Packing List",
    "Certificate Of Origin",
    "GSP / ISFTA",
    "CheckList",
    "Goods Regn. Checklist",
    "N-Form",
    "GR-Form",
    "SEZ Submission",
    "ICEGATE Submission",
    "GR Submission",
    "BL Instruction",
  ];

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState("");
  const [anchorEl1, setAnchorEl1] = useState(null);

  const { invoiceId } = useInvoice();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAnchorEl1(null);
  };

  const functionMap = {
    handleOpen: (event, btn) => {
      const button = event.target.closest("button");
      setAnchorEl1(button);

      // If the JSON specifies a component to open, store it
      if (btn.component) {
        setOpenComponent(btn);
      }
    },

    handleClose: () => {
      setAnchorEl1(null);
      setOpenComponent(null);
    },
  };

  // const sidebarItems = CreateNewJobSidebarItems(formData);
  const activeItem = sidebarItems[activeIndex] ?? {};
  const activeSubTab =
    activeItem?.type === "tab"
      ? activeItem.subTabs?.find((subTab) => subTab.id === activeSubIndex) ||
        activeItem.subTabs[activeSubIndex]
      : null;

  const activeNestedTab =
    activeSubTab?.type === "tab"
      ? activeSubTab.subTabs[activeNestedIndex]
      : null;

  const currentTab = activeNestedTab || activeSubTab || activeItem;

  useEffect(() => {
    setActiveSubIndex(0);
    setActiveNestedIndex(0);
  }, [activeIndex, invoiceId]);

  useEffect(() => {
    setActiveNestedIndex(0);
  }, [activeSubIndex]);

  const handleSelect = async (doc) => {
    setSelectedDoc(doc);
    handleClose();

    const exporterId = formData?.general?.exporterMasterId;

    try {
      const response = await triggerGetDocument({
        templatetype: doc, // e.g. "CheckList"
        jobid: exporterId, // rename correctly if it's actually jobid
      }).unwrap();
      //  🔥 Handle PDF binary data properly
      const blob = new Blob([response], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank"); // open PDF in new tab
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  useEffect(() => {
    if (formData?.general?.processingId) {
      setProcessingId(formData?.general?.processingId);
    }
  }, [formData]);

  const getSelectedId = (data) => {
    if (Array.isArray(data)) {
      const selected = data.find((item) => item?.selected);
      return selected?.id || data[0]?.id;
    }

    if (data && typeof data === "object") {
      return data.id;
    }

    return null;
  };

  const extractIdFromTableResponse = (data, replaceMasterId) => {
    if (!data) return null;

    // array response
    if (Array.isArray(data)) {
      return data.find((i) => i.selected)?.id || data[0]?.id;
    }

    // object response
    return data?.[`${replaceMasterId}Id`] || data?.id || null;
  };

  const getTableMeta = (table, config) => {
    return {
      formDataKey: table?.id,
      apiKeyName: table?.tableApiKey,
      apiKey: config[table?.tableApiKey],
      replaceMasterId:
        table?.tableApiKey === "tableApi1"
          ? config.tableReplaceMasterId
          : table?.tableApiKey === "tableApi2"
            ? config.tableReplaceMasterId2
            : null,
    };
  };
  const resolveTableId = ({
    replaceMasterId,
    formData,
    response,
    exporterMasterId,
    exporterId,
  }) => {
    if (replaceMasterId) {
      const selected = formData?.[replaceMasterId]?.find((i) => i.selected);
      return (
        selected?.id ||
        response?.[`${replaceMasterId}Id`] ||
        exporterMasterId ||
        exporterId
      );
    }

    return exporterMasterId || exporterId;
  };

  // ==========================
  useEffect(() => {
    let isMounted = true;

    const fetchTabData = async () => {
      const isTriggerRefresh = typeof trigger === "number" && trigger > 0;
      const sidebarItems = CreateNewJobSidebarItems();
      const activeItem = sidebarItems[activeIndex];
      const activeSubTab =
        activeItem?.type === "tab"
          ? activeItem.subTabs?.find(
              (subTab) => subTab.id === activeSubIndex
            ) || activeItem.subTabs[activeSubIndex]
          : null;
      const activeNestedTab =
        activeSubTab?.type === "tab"
          ? activeSubTab.subTabs[activeNestedIndex]
          : null;
      const config = activeNestedTab || activeSubTab || activeItem;

      try {
        if (!isTriggerRefresh) {
          setIsDataFetched(false);
          setLoading(true);
        }

        setIsRequiredFieldFilled(false);
        if (
          !config?.api &&
          !config?.tableApi &&
          !config.tableApi1 &&
          !config.tableApi2
        )
          return;

        const tableConfigs = (config.data || []).filter(
          (item) => item.type === "table"
        );
        const { fetch } = apiHooks[config.api] || {};
        if (!isMounted) return; // ✅ ADDED: prevent stale updates
        const { fetchTable } = apiHooks[config.tableApi] || {};

        if (!fetch && !fetchTable && !config?.tableApi1 && !config?.tableApi2) {
          console.warn("ℹ️ No API configured for:", config?.label);
          return;
        }

        let id =
          config.id === "productMain"
            ? invoiceId
            : exporterMasterId || exporterId;
        // ✅ ENHANCED: Add replaceMasterId logic
        if (config.replaceMasterId) {
          const data = formData[config.replaceMasterId];
          if (Array.isArray(data) && data.length > 0) {
            const selectedItem = data.find((item) => item.selected);
            id = selectedItem ? selectedItem.id : data[0].id;
          } else if (data && typeof data === "object") {
            id = data.id;
          }
        }
        // ✅ ADDED: dataId logic from import version
        let dataId = null;
        if (config.attachData) {
          const dataArray = formData[config.attachData] || [];
          if (Array.isArray(dataArray) && dataArray.length > 0) {
            const selectedItem = dataArray.find((item) => item.selected);
            dataId = selectedItem ? selectedItem.id : dataArray[0].id;
          }
        }

        let payload = { id };

        // ✅ ADDED: Include dataId if available
        if (dataId) {
          payload.subId = dataId;
        }
        let response;

        if (fetch) {
          response = await fetch(payload);
        }

        let tableResponse;
        // ✅ ADDED: Form data update for non-table types (from import version)
        if (
          !["table", "tableWithFields", "formWithMultiTable"].includes(
            config.type
          )
        ) {
          setFormData((prev) => ({
            ...prev,
            [config.type == "formWithTable" ? config.id + "Form" : config.id]: {
              ...(prev[
                config.type == "formWithTable" ? config.id + "Form" : config.id
              ] || {}),
              ...response,
            },
          }));
        }
        let selectedItem = null;

        if (config.attachData && formData?.[config.attachData]) {
          const attachArray = Array.isArray(formData?.[config.attachData])
            ? formData[config.attachData]
            : [formData[config.attachData]];

          selectedItem = attachArray.find((item) => item && item.selected);
        }

        let tableId;

        if (config.tableReplaceMasterId) {
          tableId =
            response?.[`${config.tableReplaceMasterId}Id`] ||
            formData[config.tableReplaceMasterId]?.id ||
            exporterMasterId ||
            exporterId;
        } else {
          tableId =
            selectedItem?.id ||
            response?.[`${config.tableReplaceMasterId}Id`] ||
            exporterMasterId ||
            exporterId;
        }

        const tablePayload = {
          id: tableId,
        };

        if (config.tableApi) {
          tableResponse = await fetchTable(tablePayload);
        }

        let previousTableId = null;

        for (const table of tableConfigs) {
          const { apiKey, replaceMasterId } = getTableMeta(table, config);
          if (!apiKey) continue;

          const { fetchMultiTable } = apiHooks[apiKey] || {};
          if (!fetchMultiTable) continue;

          try {
            const hasReplaceMasterData =
              replaceMasterId &&
              formData?.[replaceMasterId] &&
              (Array.isArray(formData[replaceMasterId])
                ? formData[replaceMasterId].length > 0
                : true);

            const requestId = hasReplaceMasterData
              ? resolveTableId({
                  replaceMasterId,
                  formData,
                  response,
                  exporterMasterId,
                  exporterId,
                })
              : (previousTableId ??
                resolveTableId({
                  replaceMasterId,
                  formData,
                  response,
                  exporterMasterId,
                  exporterId,
                }));

            const tableData = await fetchMultiTable({ id: requestId });

            // ✅ Update table data normally
            setFormData((prev) => {
              const previousData = prev[table.id] || [];
              let updatedData = tableData;

              if (Array.isArray(tableData) && tableData.length) {
                const prevSelectedId = previousData.find(
                  (row) => row.selected
                )?.id;

                updatedData = tableData.map((row, idx) => ({
                  ...row,
                  selected: prevSelectedId
                    ? row.id === prevSelectedId
                    : idx === 0,
                }));
              }

              return { ...prev, [table.id]: updatedData };
            });

            previousTableId = extractIdFromTableResponse(
              tableData,
              replaceMasterId,
              formData
            );
          } catch (err) {
            console.error(`❌ Failed loading ${table.id}`, err);

            setFormData((prev) => ({
              ...prev,
              [table.id]: [],
            }));

            continue;
          }
        }

        if (["table", "tableWithFields"].includes(config.type)) {
          setFormData((prev) => {
            const previousData = prev[config.id] || [];
            let updatedData = response;

            if (Array.isArray(response) && response.length > 0) {
              const prevSelectedId = previousData.find(
                (row) => row.selected
              )?.id;

              if (prevSelectedId) {
                updatedData = response.map((row) => ({
                  ...row,
                  selected: row.id === prevSelectedId,
                }));
              } else {
                updatedData = response.map((row, idx) => ({
                  ...row,
                  selected: idx === 0,
                }));
              }
            }

            return {
              ...prev,
              [config.id]: updatedData,
            };
          });
        } else if (config.type == "formWithTable") {
          setFormData((prev) => {
            const prevData = prev[config.id] || [];
            if (JSON.stringify(prevData) === JSON.stringify(tableResponse)) {
              return prev;
            }
            return {
              ...prev,
              [config.id]: tableResponse,
            };
          });
        }
      } catch (err) {
        setLoading(false);
        console.error("Failed to fetch tab data:", err);
        if (!["table", "tableWithFields"].includes(config.type)) {
          setFormData((prev) => ({
            ...prev,
            [config.type == "formWithTable" ? config.id + "Form" : config.id]:{},
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            [config.id]: [],
          }));
        }
      } finally {
        if (isMounted) {
          // ✅ ADDED: Check if still mounted
          setLoading(false);
          setIsDataFetched(true);
        }
      }
    };

    fetchTabData();

    return () => {
      isMounted = false;
    };
  }, [activeIndex, activeSubIndex, activeNestedIndex, invoiceId, trigger]);

  const getTableConfigs = (currentTab) =>
    (currentTab?.data || []).filter((i) => i.type === "table");

  const resolveTableIdConditionally = (row, currentTab, fallbackKey) => {
    const tables = getTableConfigs(currentTab);

    if (!tables || tables.length === 0) {
      return {
        resolvedDataKey: fallbackKey,
        tableKey: row?.__schemaKey || "",
      };
    }

    if (!row?.__schemaKey) {
      return {
        resolvedDataKey: fallbackKey,
        tableKey: "",
      };
    }

    const matchedTable = tables.find((t) => t.schemaKey === row.__schemaKey);

    return {
      resolvedDataKey: matchedTable?.id || fallbackKey,
      tableKey: matchedTable?.tableApiKey || "",
    };
  };

  const hasMultipleTables = (currentTab) => {
    const tables = (currentTab?.data || []).filter(
      (item) => item.type === "table"
    );
    return tables.length > 1;
  };

  const handleRowSelect = async (id, row, dataKey = currentTab.id) => {
    const { resolvedDataKey, tableKey } = resolveTableIdConditionally(
      row,
      currentTab,
      dataKey
    );

    if (hasMultipleTables(currentTab)) {
      setTrigger((prev) => prev + 1);
    }
    if (!isEditing && tableKey) {
      setActiveTableId(tableKey);
    } 

    setFormData((prev) => ({
      ...prev,
      [resolvedDataKey]: (prev[resolvedDataKey] || []).map((r) => ({
        ...r,
        selected: r?.id === (id?.id || id),
      })),
    }));
  };

  const resolveDeleteProcess = (currentTab, tableApiKey, apiHooks) => {
    if (tableApiKey) {
      const tableApi = currentTab[tableApiKey] || {};

      return (apiHooks[tableApi] || {}).deleteFn;
    }

    if (currentTab?.tableApi) {
      return (apiHooks[currentTab.tableApi] || {}).deleteTableFn;
    }

    if (currentTab?.api) {
      return (apiHooks[currentTab.api] || {}).deleteFn;
    }

    return null;
  };

  const resolveTableIdFromApiKey = (currentTab, tableApiKey) => {
    if (!currentTab?.data || !tableApiKey) return null;

    const matched = currentTab.data.find(
      (item) => item.type === "table" && item.tableApiKey === tableApiKey
    );

    return matched?.id || null;
  };

  const handleDelete = async (id, tableApiKey) => {
    try {
      setLoading(true);
      if (!currentTab?.api && !tableApiKey) {
        console.warn("⚠️ No API configured for:", currentTab?.label);
        return;
      }

      const deleteProcess = resolveDeleteProcess(
        currentTab,
        tableApiKey,
        apiHooks
      );

      if (!deleteProcess) {
        console.error(
          "❌ deleteProcess NOT FOUND. Check mapping in OrganizationHookMap."
        );
        return;
      }

      const response = await deleteProcess?.(id).unwrap();

      setFormData((prev) => {
        let targetKey = currentTab?.id;
        if (
          (!prev[targetKey] || Object.keys(prev[targetKey]).length === 0) &&
          tableApiKey
        ) {
          const resolvedId = resolveTableIdFromApiKey(currentTab, tableApiKey);
          if (resolvedId) {
            targetKey = resolvedId;
          }
        }

        const existingArray = prev[targetKey] || [];
        const updatedArray = existingArray.filter(
          (r) => String(r.id) !== String(id.id)
        );

        return {
          ...prev,
          [targetKey]: updatedArray,
        };
      });

      const ok =
        response?.data?.statusCode === 200 || response?.statusCode === 200;

      setSuccessDialogConfig({
        label: ok ? "Success" : "Failure",
        title: "",
        subtitle: (
          <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
            {response?.data?.message ||
              response?.message ||
              (ok ? "Data deleted successfully" : "Something went wrong")}
          </strong>
        ),
        buttonText: "OK",
        IconComponent: ok ? LuCheck : BiSolidError,
        status: ok ? "success" : "error",
      });

      setShowSuccessDialog(true);

      return response;
    } catch (err) {
      console.error("❌ ERROR in handleDelete():", err);

      setSuccessDialogConfig({
        label: "Failure",
        title: "",
        subtitle: (
          <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
            {err?.data?.message || "Something went wrong"}
          </strong>
        ),
        buttonText: "OK",
        status: "error",
        icon: BiSolidError,
      });

      setShowSuccessDialog(true);

      throw err;
    } finally {
      setLoading(false);
      setTrigger((prev) => prev + 1);
    }
  };

  // 🧩 Generic Extra API Handler
  const extraHandleSave = async (extraApi, updatedData, name) => {
    try {
      if (!extraApi) return;

      const apiSet = apiHooks[extraApi];
      if (!apiSet) {
        console.warn(`⚠️ No API found for ${extraApi}`);
        return;
      }

      const { fetch, create, update } = apiSet;

      let extraResponse;

      let id = exporterId;

      const cleanData = Object.fromEntries(
        Object.entries(updatedData || {}).filter(
          ([_, v]) => v != null && v !== ""
        )
      );
      // GET process with query params
      if (fetch) {
        let data = new URLSearchParams(cleanData).toString();
        extraResponse = await fetch({
          id,
          data,
        });
      }

      // CREATE process
      else if (create) {
        extraResponse = await create({ id: exporterId, ...cleanData }).unwrap();
      }

      // UPDATE process
      else if (update) {
        extraResponse = await update({ id: exporterId, ...cleanData }).unwrap();
      }

      setShowForm(false);
      return extraResponse;
    } catch (err) {
      console.error(`❌ Extra API failed for ${extraApi}:`, err);
    }
  };

  const flattenDataTable = (obj) => {
    if (obj === null || obj === undefined) return obj;

    const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;

    // If obj is a string, check if it's an ISO date
    if (typeof obj === "string") {
      if (isoRegex.test(obj)) {
        const parsed = dayjs(obj);
        if (parsed.isValid()) return parsed.format("DD-MM-YYYY HH:mm:ss");
      }
      return obj;
    }

    // If obj is a number, boolean, or other primitive, return as is
    if (typeof obj !== "object") return obj;

    // If obj is an array, map recursively
    if (Array.isArray(obj)) {
      return obj.map((item) => flattenDataTable(item));
    }

    // Now obj is a plain object
    if ("name" in obj) return obj.name;
    if ("label" in obj) return obj.label;

    // Otherwise, recurse for nested objects
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => {
        // If value is string and matches ISO, convert it
        if (typeof value === "string" && isoRegex.test(value)) {
          const parsed = dayjs(value);
          return [
            key,
            parsed.isValid() ? parsed.format("DD-MM-YYYY HH:mm:ss") : value,
          ];
        }

        // Otherwise, recurse
        return [key, flattenDataTable(value)];
      })
    );
  };

  useEffect(() => {}, [formData]);

  const handleSave = async (type) => {
    console.log(type, "type checcking");
    try {
      let filledData = formRef.current ? await formRef.current.submit() : {};
      console.log("handleSave", filledData);

      if (!Object.keys(filledData).length && dynamicTrackingRef?.current) {

        filledData = dynamicTrackingRef.current;
      }

      if (!Object.keys(filledData).length) {
        console.groupEnd();
        return;
      }

      const updatedData = Object.fromEntries(
        Object.entries(filledData).map(([key, val]) => [key, val?.id ?? val])
      );

      const attachData = Object.fromEntries(
        Object.entries(filledData).map(([key, val]) => [key, val?.name ?? val])
      );

      type === "table" ? setLoading(true) : setSaveLoading(true);

      const resolveConfig = (items, id) => {
        for (const item of items) {
          if (item.id === id) return item;
          if (item.subTabs) {
            const found = resolveConfig(item.subTabs, id);
            if (found) return found;
          }
        }
        return null;
      };

      const activeItem = sidebarItems[activeIndex];
      const activeSubTab = activeItem.subTabs?.find(
        (subTab) => subTab.id === activeSubIndex
      );
      const activeNestedTab = activeSubTab?.subTabs?.[activeNestedIndex];

      const config = dialogOwnerConfig
        ? resolveConfig(sidebarItems, dialogOwnerConfig)
        : activeNestedTab || activeSubTab || activeItem;
      if (extraApi) {
        const extraResponse = await extraHandleSave(
          extraApi,
          updatedData,
          config.id
        );

        const dataToStore = Array.isArray(extraResponse)
          ? extraResponse
          : [extraResponse];

        setFormData((prev) => ({
          ...prev,
          [config.id]: dataToStore,
        }));

        setSuccessDialogConfig({
          label: "Success",
          title: "",
          subtitle: (
            <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
              {"Filtered data loaded successfully"}
            </strong>
          ),
          buttonText: "OK",
          IconComponent: LuCheck,
          status: "success",
        });
        setShowSuccessDialog(true);

        return;
      }

      if (config.id === "general" && formData?.general?.processingId) {
        updatedData.processingId = formData?.general?.processingId;
      }

      const currentActiveId =
        activeNestedTab?.id || activeSubTab?.id || activeItem?.id;
      if (
        !config?.api &&
        !config?.tableApi &&
        !config?.tableApi1 &&
        !config?.tableApi2
      ) {
        console.warn("ℹ️ No API configured for:", config?.label);
        return;
      }

      let exporterId = exporterMasterId;

      if (config.replaceMasterId) {
        const data = formData[config.replaceMasterId];

        if (Array.isArray(data) && data.length > 0) {
          const selectedItem = data.find((item) => item.selected);
          exporterId = selectedItem ? selectedItem.id : data[0].id;
        } else if (data && typeof data === "object") {
          exporterId = data.id;
        }
      }
      const replaceData = formData[config.tableReplaceMasterId];

      const tableExporterId = config.tableReplaceMasterId
        ? getSelectedId(replaceData) ||
          formData[`${config.tableReplaceMasterId}Form`]?.[
            `${config.tableReplaceMasterId}Id`
          ]
        : exporterMasterId || exporterId;

      let response;
      let tableResponse;
      const apiSet = apiHooks[config.api] || {};
      const { create, update } = apiSet;

      if (config.type === "formWithTable") {
        const formAPI = apiHooks[config.api] || {};
        const tableAPI = apiHooks[config.tableApi] || {};
        const { create: createForm, update: updateForm } = formAPI;
        const { create: createTable, update: updateTable } = tableAPI;

        const formPayload = config.mapper?.(updatedData) || updatedData;
        const tablePayload = { ...updatedData };

        if (type !== "table") {
          if (filledData.selectedId && updateForm && isEditing) {
            response = await updateForm({
              id: exporterId,
              ...formPayload,
            }).unwrap();
          } else if (createForm) {
            response = await createForm({
              id: exporterId,
              ...formPayload,
            }).unwrap();
          }
          const formId = response?.data || response?.id;
          if (formId) tablePayload.formId = formId;
        } else {
          delete tablePayload.selectedId;
          if (filledData.selectedId && updateTable && isEditing) {
            tableResponse = await updateTable({
              id: tableExporterId,
              subId: filledData.selectedId,
              ...tablePayload,
            }).unwrap();
          } else if (createTable) {
            tableResponse = await createTable({
              id: tableExporterId,
              ...tablePayload,
            }).unwrap();
          }
        }
      } else if (config.type === "formWithMultipleTable") {
        const multiTableReplaceId =
          type === "tableApi2"
            ? config.tableReplaceMasterId2
            : config.tableReplaceMasterId;

        const replaceData = formData[multiTableReplaceId];
        const multiTableReplaceIdData =
          multiTableReplaceId && getSelectedId(replaceData);

        const tableAPI = apiHooks[config?.[type]] || {};
        const { create, update } = tableAPI;
        const formPayload = config.mapper?.(updatedData) || updatedData;
        const tablePayload = { ...formPayload };

        if (filledData.selectedId && update && isEditing) {
          tableResponse = await update({
            id: multiTableReplaceIdData,
            subId: filledData.selectedId,
            ...tablePayload,
          }).unwrap();
        } else if (create) {
          tableResponse = await create({
            id: multiTableReplaceIdData,
            ...tablePayload,
          }).unwrap();
        }
        // }
      } else {
        const id = filledData.selectedId;

        let mergedData = updatedData;

        if (!formData?.general?.exporterJobNumber) {
          const generalMaster = formData?.general || {};

          const masterFiltered = Object.keys(defaultValues).reduce(
            (acc, key) => {
              if (generalMaster[key] !== undefined) {
                acc[key] = generalMaster[key];
              }
              return acc;
            },
            {}
          );
          mergedData = {
            ...updatedData,
            ...masterFiltered,
          };
        }

        const data = config.mapper?.({
          ...mergedData,
          ...(config.id === "tracking" ? dynamicTrackingRef.current : {}),
        }) || {
          ...mergedData,
          ...(config.id === "tracking" ? dynamicTrackingRef.current : {}),
        };

        let attachId = null;

        if (config.attachData) {
          const dataArray = formData[config.attachData] || [];
          if (Array.isArray(dataArray) && dataArray.length > 0) {
            const selectedItem = dataArray.find((item) => item.selected);
            attachId = selectedItem ? selectedItem.id : dataArray[0].id;
          }
        }

        const payload = {
          id: exporterId,
          ...data,
          ...(attachId && { dataId: attachId }),
        };

        delete payload.selectedId;
        if (id && update) {
          response = await update({ subId: id, ...payload }).unwrap();
        } else if (create) {
          if (config.id == "general" && exporterMasterId) {
            response = await update({ ...payload }).unwrap();
          } else {
            response = await create(payload).unwrap();
            if (config.id == "general")
              setExporterMasterId(response?.data),
              handlerefresh(response?.data);
          }
        }
      }

      // 🟢 Update form data in state if needed
      if (!dialogOwnerConfig || dialogOwnerConfig === currentActiveId) {
        let rowData = null;
        let newRowId = null;

        if (config.type === "formWithTable" && tableResponse) {
          rowData = flattenDataTable(attachData);
          newRowId = tableResponse?.data?.id || tableResponse?.data;
        } else if (["table"].includes(config.type) && response) {
          rowData = flattenDataTable(attachData);
          newRowId = response?.data?.id || response?.data;
        }
      }
      handleCloseForm();
      try {
        if (formRef.current && formRef.current.reset) {
          await formRef.current.reset();
          
        }
      } catch (resetError) {
        console.warn("⚠️ Form reset failed:", resetError);
      }

      // 🟢 Show Success Dialog
      const success =
        response?.success === true ||
        response?.data?.success === true ||
        response?.data?.statusCode === 200 ||
        response?.statusCode === 200 ||
        tableResponse?.data?.statusCode === 200 ||
        tableResponse?.statusCode === 200;
      setSuccessDialogConfig({
        label: success ? "Success" : "Failure",
        title: "",
        subtitle: (
          <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
            {response?.data?.message ||
              response?.message ||
              "Data save successfully"}
          </strong>
        ),
        buttonText: "OK",
        IconComponent: success ? LuCheck : BiSolidError,
        status: success ? "success" : "error",
      });
      setShowSuccessDialog(true);

      return { response, tableResponse };
    } catch (err) {
      console.error("❌ Save failed:", err);
      setSuccessDialogConfig({
        label: "Failure",
        title: "",
        subtitle: (
          <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
            {err?.data?.message || "Something went wrong"}
          </strong>
        ),
        buttonText: "OK",
        status: "error",
        icon: BiSolidError,
      });
      setShowSuccessDialog(true);
      throw err;
    } finally {
      if (!extraApi) {
        setTrigger((prev) => prev + 1);
      }
      setLoading(false);
      setSaveLoading(false);
      setExtraApi(null);
      setActiveTableId(null);
    }
  };

  const renderButtons = (
    subButtons = [],
    subcheckBox = [],
    schema,
    label,
    type,
    id
  ) => {
    if (!subButtons.length && !subcheckBox.length) return null;
    return (
      <Box
        display="flex"
        justifyContent={subcheckBox.length > 0 ? "space-between" : "flex-end"}
        alignItems="center"
        mb={2}
      >
        {subcheckBox.length > 0 && (
          <Box display="flex" flexWrap="wrap" gap={1} px={3}>
            {subcheckBox.map((item, idx) => (
              <CheckboxBox
                key={idx}
                checkboxLabel={item.label}
                value={[item.label] || false}
                onChange={(val) => handleCheckboxChange(item.label, val)}
              />
            ))}
          </Box>
        )}

        {subButtons.length > 0 && (
          <Box display="flex" gap={1}>
            {subButtons.map((btn, idx) => {
              const Icon = iconMap[btn.icon];
              return (
                <OutLinedButton
                  key={idx}
                  label={btn.label}
                  startIcon={Icon ? <Icon /> : null}
                  onClick={() => {
                    if (btn.onClick === "openForm") {
                      openForm(schema, label, id);
                    } else if (typeof btn.onClick === "function") {
                      btn.onClick();
                    }
                  }}
                  sx={{ border: "none" }}
                />
              );
            })}
          </Box>
        )}
      </Box>
    );
  };

  const handleChange = () => {};

  const tableSchema = currentTab?.data
    ?.filter((item) => item.type === "table")
    ?.map((item) => item.schema);

  const handleActions = (payload) => {
    const { action, data, btnData } = payload;
    let ComponentToRender;
    switch (action) {
      case "openDialog":
        openForm(data?.schema, "test");
        break;
      case "reInitializeRequirement":
        handleReInitializeRequirement();
        break;
      case "openSubDialog":
        ComponentToRender = dynamicComponentMap[data.subComponent];
        if (!ComponentToRender) {
          console.warn(`⚠️ No component found for ${data.subComponent}`);
          return;
        }
        setSubDialogConfig({
          Component: ComponentToRender,
          props: data.props || {},
        });
        // setShowForm(false);
        setSubDialogOpen(true);

        break;
      case "openButtonSubDialog":
        const subBtn = data?.buttons?.find((btn) => btn.subComponent);
        ComponentToRender = btnData
          ? dynamicComponentMap[btnData.subComponent]
          : null;

        if (!ComponentToRender) {
          console.warn(
            `⚠️ No component found for ${subBtn?.subComponent || "unknown subComponent"}`
          );
          return;
        }

        setSubDialogConfig({
          Component: ComponentToRender,
          props: data.props || {},
        });
        // setShowForm(false);
        setSubDialogOpen(true);
        break;

      case "openButtonDialog":
        const button = event.target.closest("button");
        setAnchorEl1(button);
        setOpenComponent({ component: data?.subComponent });
        break;
      case "refresh":
        handleRefresh(data?.api);
        break;
      case "navigate":
        navigate(data?.navigateTo);
        break;
      case "viewProduct":
        setActiveIndex(6);
        break;
      case "openFile": {
        const safePayload = {
          type,
          action,
          data, // pass full data object
          filename, // pass filename fallback
        };
        handleSubmit(safePayload);
        break;
      }
      case "active":
        setAnchorEl1(true);
        setOpenComponent({ component: data });
        dynamicComponentMap[data];
        break;
      default:
        console.warn("Unknown action:", action);
    }
  };

  const handleSubmit = ({ type, action, data, filename }) => {
    if (action === "openFile") {
      const targetFile =
        componentMap[currentActiveId] ||
        data?.filename?.trim() ||
        filename?.trim();

      if (componentMap[targetFile]) {
        setActiveFile(targetFile);
        setOpeningForm(false);
      } else {
        console.warn("❌ No component found for", targetFile);
      }
    }
  };

  const handleRefresh = async (api) => {
    if (!exporterMasterId) return;
    try {
      setSaveLoading(true);
      const { fetch } = apiHooks[api] || {};
      if (!fetch) {
        console.warn(`No fetch method found for API: ${api}`);
        return;
      }
      const response = await fetch({ id: exporterMasterId });
      setFormData((prev) => ({
        ...prev,
        [currentTab.id]: response,
      }));
    } catch (err) {
      console.error("Refresh error:", err);
    } finally {
      setSaveLoading(false);
    }
  };

  const initialSubTabs = useMemo(
    () =>
      activeItem.subTabs?.map((tab) => ({
        id: tab.id,
        label: tab.label,
        disabled: tab.disabled,
        hide: tab.hide,
      })) || [],
    [activeItem]
  );

  useEffect(() => {
    setSubTabs(initialSubTabs);
  }, [initialSubTabs]);

  setEximData(eximData);
  const handleDynamicTabUpdate = (eximCode) => {
    if (eximCode === undefined) return;
    const matchEximCode = eximData?.find((item) => item.id === eximCode);
    setSubTabs((prevTabs) =>
      updateTabsVisibilityGeneric(matchEximCode?.name ?? null, prevTabs)
    );
  };

  const updateTabsVisibilityGeneric = (eximCode, tabs) => {
    if (!eximCode) {
      return tabs.map((tab) =>
        tab.hide === false ? { ...tab, hide: true } : tab
      );
    }
    const visibleTabs = Object.keys(tabToEximCodeMap).filter((tabKey) =>
      tabToEximCodeMap[tabKey].includes(eximCode)
    );

    const visibleIds = visibleTabs.map((v) => v.toLowerCase());

    const updatedTabs = tabs.map((tab) => {
      const tabId = tab.id?.toLowerCase();

      const shouldBeVisible = visibleIds.includes(tabId);

      if (tab.hide === shouldBeVisible) {
        return { ...tab, hide: !shouldBeVisible };
      }
      return tab;
    });

    return updatedTabs;
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",

        gap: "8px",
        overflow: "hidden",
        height: "100vh",
        maxWidth: "100%",
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        flexWrap="wrap"
        flexShrink={0}
      >
        <Box
          display="flex"
          flexDirection="column"
          sx={{
            color: "var(--brand-910)",
            fontSize: "13px",
            cursor: "pointer",
            gap: 1,
          }}
        >
          <Typography variant="heading">Create New Job</Typography>
          <Box
            display="flex"
            alignItems="center"
            variant="bodySmallStrong"
            gap={1}
            sx={{
              color: "var(--link-blue)",
              cursor: "pointer",
            }}
            onClick={async () => {
              // localStorage.removeItem("exporterMasterId");
              navigate(navurl.Dashboard);
              setDisableCopy(false);
              localStorage.removeItem("copiedJobData");

              await new Promise((resolve) => {
                clearAll({});
                setTimeout(resolve, 800); // allow context to clear
              });
            }}
          >
            <LuArrowLeft style={{ color: "var(--brand-600)", fontSize: 20 }} />
            Back to Export Dashboard
          </Box>
        </Box>

        <Box
          display="flex"
          flexWrap="wrap"
          alignItems="center"
          justifyContent="flex-end"
          gap={2}
          sx={{ flex: 1, flexWrap: "nowrap" }}
        >
          <IconButton
            onClick={handlerefresh}
            sx={{
              border: "1px solid var(--brand-600)",
              color: "var(--brand-600)",
              borderRadius: 2,
              backgroundColor: "var(--gray-0)",
              height: 40,
              width: 36,
              p: 0,
              "&:hover": {
                backgroundColor: "var(--gray-0)",
              },
            }}
          >
            <LuRefreshCw size={20} />
          </IconButton>
          <OutLinedButton
            label={isActivation && isEditMode ? "Active" : "In Active"}
            variant="bodySmallMedium"
            onClick={() =>
              handleActions({
                action: "active",
                data: "ActiveDialog",
              })
            }
            sx={{
              color:
                isActivation && isEditMode
                  ? "var(--green-600)"
                  : "var(--gray-400)",
              px: 2,
              border:
                isActivation && isEditMode
                  ? "1px solid var(--green-600)"
                  : "1px solid var(--gray-400)",
              borderRadius: 2,
              // fontWeight: 500,
              textTransform: "none",
              backgroundColor: "var(--gray-0)",
              "&:hover": {
                backgroundColor: "var(--gray-0)",
              },
              // fontSize: "14px",
            }}
          />
          <OutLinedButton
            label="Standard Documents"
            variant="bodySmallMedium"
            startIcon={<FiFileText />}
            endIcon={<LuChevronDown />}
            onClick={handleClick}
            sx={{
              color: "var(--brand-600)",
              px: 2,
              border: "1px solid var(--brand-600)",
              borderRadius: 2,
              // fontWeight: 500,
              textTransform: "none",
              backgroundColor: "var(--gray-0)",
              "&:hover": {
                backgroundColor: "var(--gray-0)",
              },
              // fontSize: "14px",
            }}
          />
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            PaperProps={{
              sx: {
                maxHeight: 225, // 👈 reduce the dropdown height here
                width: 232,
                overflowY: "auto", // 👈 scroll when items exceed height
                borderRadius: 2,
              },
            }}
            MenuListProps={{
              sx: {
                py: 0, // 👈 optional: remove extra padding from the list
              },
            }}
          >
            {documentOptions.map((doc, idx) => (
              <MenuItem
                key={idx}
                onClick={() => handleSelect(doc)}
                sx={{
                  fontSize: "14px",
                  py: 1,
                  width: 232,
                }}
              >
                {doc}
              </MenuItem>
            ))}
          </Menu>

          <OutLinedButton
            label="Copy Job"
            variant="bodySmallMedium"
            startIcon={<LuCopy />}
            onClick={copyJobData} // ✅ separate function
            disabled={disableCopy} // ✅ use the state here
            sx={{
              color: "var(--brand-600)",
              px: 2,
              border: "1px solid var(--brand-600)",
              borderRadius: 2,
              textTransform: "none",
              backgroundColor: "var(--gray-0)",
              "&:hover": {
                backgroundColor: "var(--gray-0)",
              },
            }}
          />

          <>
            {/* Your existing button */}
            <OutLinedButton
              label="Import File"
              variant="bodySmallMedium"
              startIcon={<LuFileMinus />}
              sx={{
                color: "var(--brand-600)",
                px: 2,
                border: "1px solid var(--brand-600)",
                borderRadius: 2,
                textTransform: "none",
                backgroundColor: "var(--gray-0)",
                "&:hover": { backgroundColor: "var(--gray-0)" },
              }}
              onClick={handleImportClick} // triggers hidden file input
            />

            {/* Hidden file input */}
            <input
              type="file"
              accept=".csv"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileSelect}
            />
          </>

          <BlackButton
            label="Add New Job"
            variant="bodySmallMedium"
            startIcon={<LuPlus size={21} />}
            sx={{
              width: "170px",
              mt: 1,
              color: "var(--gray-0)",
              borderRadius: 2,
              textTransform: "none",
              backgroundColor: "var(--brand-600)",
            }}
            onClick={goToCreateNewJob}
          />
        </Box>
      </Box>

      {/* Render the   Filter Box  and  */}
      <Box
        sx={{
          flexShrink: 0,
          width: "100%",
          backgroundColor: "var(--gray-0)",
          borderRadius: 2,
          border: "1px solid var(--gray-100)",
        }}
      >
        {/* used fromData state to handle the header menu, instead if using separate state */}
        <CreateFilterBox
          handleChange={handleChange}
          showAdvancedFilters={showAdvancedFilters}
          setShowAdvancedFilters={setShowAdvancedFilters}
          data={formData["general"]}
          exporterMasterId={exporterMasterId}
        />
      </Box>

      <Box
        sx={{
          flexGrow: 1,
          minHeight: 0,
          backgroundColor: "var(--gray-0)",
          width: "100%",
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CreateJobLayout
          disabled={!exporterMasterId && activeIndex !== 0} // ✅
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
          sx={{
            width: "100%",
            maxWidth: "90%",
            mx: "auto",
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box key={activeIndex} sx={{ width: "100%", mb: 2 }}>
            <SectionHeader
              title={`${activeItem.label}`}
              buttons={[
                ...(activeItem?.buttons?.map((btn) => {
                  const Icon = iconMap[btn.icon];
                  return {
                    ...btn,
                    icon: Icon ? <Icon /> : null,
                    onClick: (event) => {
                      if (btn.action === "openForm") {
                        const schema = btn.schema || activeItem.schema;
                        const label = activeItem.label;
                        const extraApi = btn.extraApi;
                        openForm(schema, label,null, btn.ownerConfig, extraApi);
                      } else {
                        if (btn.onClick) {
                          // 🔹 Custom click exists → call it
                          btn.onClick(event, btn);
                        } else {
                          // 🔹 No custom click → fallback to handleActions
                          handleActions({
                            type: activeItem.type,
                            action: btn.action,
                            data: activeItem,
                            btnData: btn,
                          });
                        }
                      }
                    },
                  };
                }) || []),
                ...(activeItem.type === "tab"
                  ? activeSubTab?.buttons?.map((btn) => {
                      const Icon = iconMap[btn.icon];
                      return {
                        ...btn,
                        icon: Icon ? <Icon /> : null,
                        disabled: btn.disabled,
                        onClick: (event) => {
                          if (btn.action === "openForm") {
                            const schema = btn.schema || activeSubTab.schema;
                            const label = btn.label || activeSubTab.label;
                            openForm(schema, label);
                          } else {
                            if (btn.onClick) {
                              // 🔹 Custom click exists → call it
                              btn.onClick(event, btn);
                            } else {
                              // 🔹 No custom click → fallback to handleActions
                              handleActions({
                                type: activeSubTab.type,
                                action: btn.action.toLowerCase(),
                                data: activeSubTab,
                              });
                            }
                          }
                        },
                      };
                    }) || []
                  : []),
              ]}
              titleButtons={[
                ...(activeItem?.titleButtons?.map((btn) => {
                  const Icon = iconMap[btn.icon];
                  return {
                    ...btn,
                    icon: Icon ? <Icon /> : null,
                    onClick: () => {
                      if (btn.action === "openForm") {
                        openForm(activeItem.schema, activeItem.label);
                      } else {
                        const fn = functionMap[btn.onClick];
                        if (typeof fn === "function") {
                          fn(event, btn); // pass event if needed
                        }
                        // btn.onClick?.();
                      }
                    },
                  };
                }) || []),

                ...(activeItem.type === "tab"
                  ? activeSubTab?.titleButtons?.map((btn) => {
                      const Icon = iconMap[btn.icon];
                      return {
                        ...btn,
                        icon: Icon ? <Icon /> : null,
                        onClick: () => {
                          if (btn.action === "openForm") {
                            const schema = btn.schema || activeSubTab.schema;
                            const label = btn.label || activeSubTab.label;
                            openForm(schema, label);
                          } else {
                            btn.onClick?.();
                          }
                        },
                      };
                    }) || []
                  : []),
              ]}
            />

            <Box>
              {activeItem?.type === "form" && (
                <Box sx={{ width: "100%", px: 2, py: 1 }}>
                  {/* For all form generator, pass the compkey, so that formGenerator will display the specific tab's initialvalue and pass the formRef, so that when submit the updated values will receive in the handleSave function*/}
                  <FormGenerator
                    compKey={activeItem.id}
                    key={activeItem.id}
                    schema={activeItem.schema}
                    onSubmit={handleActions}
                    ref={formRef}
                    onRequiredFieldsChange={(allFilled) =>
                      setIsRequiredFieldFilled(allFilled)
                    } // ✅ pass this
                  />
                </Box>
              )}

              {activeItem?.type === "table" && (
                <Box>
                  {/* For all table generator, pass the compkey, so that tableGenerator will display the specific tab's initialvalue and pass the formRef, so that when submit the updated values will receive in the handleSave function*/}
                  <TableGenerator
                    handleSave={handleSave}
                    handleDelete={handleDelete}
                    label={activeItem.label}
                    ref={formRef}
                    compKey={activeItem.id}
                    key={activeItem.id}
                    handlers={handlers}
                    visibleFields={activeItem.visibleFields}
                    expandedFields={activeItem.expandedFields}
                    actions={activeItem?.actions || null}
                    loading={saveLoading}
                    onSubmit={handleActions}
                  />
                </Box>
              )}

              {activeItem?.type === "tableWithFields" && (
                <Box>
                  {/* For all table with field generator, pass the compkey, so that TableWithFieldGenerator will display the specific tab's initialvalue and pass the formRef, so that when submit the updated values will receive in the handleSave function*/}
                  <TableWithFieldGenerator
                    compKey={activeItem.id}
                    key={activeItem.id}
                    handleSave={handleSave}
                    handleDelete={handleDelete}
                    label={activeItem.label}
                    ref={formRef}
                    groupedHeaders={activeItem.groupedHeaders}
                    visibleFields={activeItem.visibleFields}
                    expandedFields={activeItem.expandedFields}
                    actions={activeItem?.actions}
                    tableSx={activeItem?.sx}
                  />
                </Box>
              )}

              {activeItem?.type === "formWithTable " && (
                <Box>
                  <FormGenerator
                    compKey={activeItem.id}
                    key={activeItem.id}
                    schema={activeItem.formSchema}
                    onSubmit={handleActions}
                    ref={formRef}
                    onRequiredFieldsChange={(allFilled) =>
                      setIsRequiredFieldFilled(allFilled)
                    } // ✅ pass this
                  />
                  <TableGenerator
                    compKey={activeItem.id}
                    key={activeItem.id}
                    handleSave={handleSave}
                    handleDelete={handleDelete}
                    label={activeItem.label}
                    ref={formRef}
                    handlers={handlers}
                    visibleFields={activeItem.visibleFields}
                    expandedFields={activeItem.expandedFields}
                    actions={activeItem?.actions || null}
                  />
                </Box>
              )}

              {/* Render custom component if provided */}
              {activeItem.component &&
                (() => {
                  const Component = activeItem.component;
                  return (
                    <Component
                      {...activeItem.componentProps}
                      formData={formData}
                      setFormData={setFormData}
                      dynamicTrackingRef={dynamicTrackingRef}
                      handleSave={handleSave}
                      handleDelete={handleDelete}
                      handleRowSelect={handleRowSelect}
                    />
                  );
                })()}

              {activeItem?.type === "tab" && (
                <Box>
                  <CustomTabs
                    tabs={subTabs}
                    activeTab={activeSubIndex}
                    setActiveTab={setActiveSubIndex}
                  />
                  {activeSubTab?.checkBox?.length > 0 && (
                    <Box display="flex" flexWrap="wrap" gap={1} px={3}>
                      {activeSubTab.checkBox.map((item, idx) => (
                        <CheckboxBox
                          key={idx}
                          checkboxLabel={item.label}
                          value={[item.label] || false} // use your state
                          onChange={(val) =>
                            handleCheckboxChange(item.label, val)
                          }
                        />
                      ))}
                    </Box>
                  )}
                  <Box>
                    {activeSubTab?.type === "form" && activeSubTab.schema && (
                      <>
                        <Box
                          mt={2}
                          px={4}
                          display="flex"
                          flexDirection="column"
                          gap={2}
                        >
                          {/* Form */}
                          <FormGenerator
                            compKey={activeSubTab.id}
                            key={activeSubTab.id}
                            schema={activeSubTab.schema}
                            onSubmit={handleActions}
                            ref={formRef}
                            onRequiredFieldsChange={(allFilled) =>
                              setIsRequiredFieldFilled(allFilled)
                            } // ✅ pass this
                            onFieldValueChange={(value, fieldName) => {
                              handleDynamicTabUpdate(value); // your logic here
                            }}
                          />
                        </Box>
                      </>
                    )}
                    {/* Render current sub-tab's table */}
                    {activeSubTab?.type === "table" && (
                      <>
                        {(activeSubTab?.subcheckBox ||
                          activeSubTab?.subButtons) && (
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            flexWrap="wrap"
                            gap={2}
                            mb={2}
                            ml={2} // optional left padding
                          >
                            {/* Left: Checkboxes */}
                            {activeSubTab?.subcheckBox?.length > 0 && (
                              <Box display="flex" flexWrap="wrap" gap={1}>
                                {activeSubTab.subcheckBox.map((item, idx) => (
                                  <CheckboxBox
                                    key={idx}
                                    checkboxLabel={item.label}
                                    value={[item.label] || false}
                                    onChange={(val) =>
                                      handleCheckboxChange(item.label, val)
                                    }
                                  />
                                ))}
                              </Box>
                            )}
                            {/* Right: SubButtons always flex-end */}
                            {activeSubTab?.subButtons?.length > 0 && (
                              <Box
                                display="flex"
                                flexWrap="wrap"
                                justifyContent="flex-end"
                                gap={1}
                                flexGrow={1}
                              >
                                {activeSubTab.subButtons.map((btn, idx) => {
                                  const Icon = iconMap[btn.icon];
                                  return (
                                    <OutLinedButton
                                      key={idx}
                                      label={btn.label}
                                      startIcon={Icon ? <Icon /> : null}
                                      onClick={() => {
                                        if (btn.onClick === "openForm") {
                                          openForm(
                                            activeSubTab.schema,
                                            activeSubTab.label
                                          );
                                        } else if (
                                          typeof btn.onClick === "function"
                                        ) {
                                          btn.onClick();
                                        }
                                      }}
                                      sx={{
                                        mr: 1,
                                        mb: 1,
                                        border: "none",
                                        ...(btn.sx || {}),
                                      }}
                                    />
                                  );
                                })}
                              </Box>
                            )}
                          </Box>
                        )}

                        <TableGenerator
                          compKey={activeSubTab.id}
                          key={activeSubTab.id}
                          handleSave={handleSave}
                          handleDelete={handleDelete}
                          visibleFields={activeSubTab.visibleFields}
                          expandedFields={activeSubTab.expandedFields}
                          label={activeSubTab.label}
                          ref={formRef}
                          handlers={handlers}
                          actions={activeSubTab?.actions || null}
                          onSubmit={handleActions} // ✅ VERY IMPORTANT
                        />
                      </>
                    )}

                    {activeSubTab?.type === "tableWithFields" && (
                      <TableWithFieldGenerator
                        compKey={activeSubTab.id}
                        key={activeSubTab.id}
                        handleSave={handleSave}
                        handleDelete={handleDelete}
                        label={activeSubTab.label}
                        ref={formRef}
                        groupedHeaders={activeSubTab.groupedHeaders}
                        visibleFields={activeSubTab.visibleFields}
                        expandedFields={activeSubTab.expandedFields}
                        actions={activeSubTab?.actions}
                        tableSx={activeSubTab?.sx}
                      />
                    )}
                    {activeSubTab?.type === "formWithTable" && (
                      <Box>
                        {activeSubTab?.checkBox?.length > 0 && (
                          <Box
                            display="flex"
                            flexWrap="wrap"
                            gap={1}
                            mb={2}
                            px={3}
                          ></Box>
                        )}

                        {activeSubTab.data?.map((section, idx) => {
                          if (section.type === "form") {
                            return (
                              <Box key={idx} mt={2} px={4}>
                                <FormGenerator
                                  compKey={activeSubTab.id + "Form"}
                                  key={activeSubTab.id + "Form"}
                                  schema={section.schema}
                                  onSubmit={handleActions}
                                  ref={formRef}
                                  onRequiredFieldsChange={(allFilled) =>
                                    setIsRequiredFieldFilled(allFilled)
                                  } // ✅ pass this
                                />
                              </Box>
                            );
                          }

                          if (section.type === "table") {
                            return (
                              <Box>
                                {renderButtons(
                                  section?.subButtons,
                                  section?.subcheckBox, // <-- pass checkboxes here
                                  section?.schema,
                                  section?.label,
                                  activeSubTab?.type === "formWithTable"
                                )}
                                <TableGenerator
                                  compKey={activeSubTab.id}
                                  key={activeSubTab.id}
                                  handleSave={handleSave}
                                  handleDelete={handleDelete}
                                  visibleFields={section.visibleFields}
                                  expandedFields={section.expandedFields}
                                  label={activeSubTab.label}
                                  ref={formRef}
                                  handlers={handlers}
                                  actions={section?.actions || null}
                                  onSubmit={handleActions}
                                />
                              </Box>
                            );
                          }

                          return null; // default
                        })}
                      </Box>
                    )}

                    {activeSubTab?.type === "formWithMultipleTable" && (
                      <Box>
                        {activeSubTab?.checkBox?.length > 0 && (
                          <Box
                            display="flex"
                            flexWrap="wrap"
                            gap={1}
                            mb={2}
                            px={3}
                          ></Box>
                        )}

                        {activeSubTab.data?.map((section, idx) => {
                          if (section.type === "form") {
                            return (
                              <Box key={idx} mt={2} px={4}>
                                <FormGenerator
                                  compKey={section.id}
                                  key={section.id}
                                  schema={section.schema}
                                  onSubmit={handleActions}
                                  ref={formRef}
                                  onRequiredFieldsChange={(allFilled) =>
                                    setIsRequiredFieldFilled(allFilled)
                                  } // ✅ pass this
                                />
                              </Box>
                            );
                          }
                          if (section.type === "table") {
                            return (
                              <Box>
                                {renderButtons(
                                  section?.subButtons,
                                  section?.subcheckBox, // <-- pass checkboxes here
                                  section?.schema,
                                  section?.label,
                                  activeSubTab?.type === "formWithTable",
                                  section?.tableApiKey
                                )}
                                <TableGenerator
                                  compKey={section.id}
                                  key={activeSubTab.id}
                                  handleSave={handleSave}
                                  handleDelete={handleDelete}
                                  visibleFields={section.visibleFields}
                                  expandedFields={section.expandedFields}
                                  label={activeSubTab.label}
                                  ref={formRef}
                                  handlers={handlers}
                                  actions={section?.actions || null}
                                  onSubmit={handleActions}
                                />
                              </Box>
                            );
                          }

                          return null; // default
                        })}
                      </Box>
                    )}

                    {activeSubTab?.type === "tab" && (
                      <>
                        <TabWithIndependentButtons
                          tabs={activeSubTab.subTabs}
                          buttons={(
                            activeSubTab.subTabs[activeNestedIndex]?.buttons ||
                            []
                          ).map((btn) => {
                            const Icon = iconMap[btn.icon];
                            return {
                              ...btn,
                              startAdornment: Icon ? <Icon /> : null,
                              sx: { border: "none", ...(btn.sx || {}) },
                              onClick: () => {
                                if (btn.onClick === "openForm") {
                                  const currentSub =
                                    activeSubTab.subTabs[activeNestedIndex];
                                  const currentId = currentSub?.id || null;

                                  setTableCompkey(currentId); // ✅ update state immediately

                                  openForm(
                                    currentSub.schema,
                                    currentSub.label,
                                    null,
                                    null, // ownerConfig
                                    null, // extraApi
                                    currentId // ✅ only send ID string, not the whole object
                                  );
                                }
                              },
                            };
                          })}
                          activeTab={activeNestedIndex}
                          setActiveTab={setActiveNestedIndex}
                        />

                        <Box mt={2}>
                          {(() => {
                            const nestedTab =
                              activeSubTab.subTabs[activeNestedIndex || 0];

                            if (
                              nestedTab?.type === "form" &&
                              nestedTab.schema
                            ) {
                              return (
                                <Box mt={2} px={4}>
                                  <FormGenerator
                                    compKey={nestedTab.id}
                                    key={nestedTab.id}
                                    schema={nestedTab.schema}
                                    onSubmit={handleActions}
                                    ref={formRef}
                                    onRequiredFieldsChange={(allFilled) =>
                                      setIsRequiredFieldFilled(allFilled)
                                    } // ✅ pass this
                                  />
                                </Box>
                              );
                            }

                            if (nestedTab?.type === "table") {
                              return (
                                <TableGenerator
                                  compKey={nestedTab.id}
                                  key={nestedTab.id}
                                  handleSave={handleSave}
                                  handlers={handlers}
                                  handleDelete={handleDelete}
                                  visibleFields={nestedTab.visibleFields}
                                  expandedFields={nestedTab.expandedFields}
                                  label={nestedTab.label}
                                  ref={formRef}
                                  actions={nestedTab?.actions || null}
                                />
                              );
                            }

                            return null;
                          })()}
                        </Box>
                      </>
                    )}
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </CreateJobLayout>
      </Box>
      {/* </Box> */}
      <Box
        sx={{
          flexShrink: 0,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "sticky",
          bottom: 0,
        }}
      >
        {/* Left Button: Declarations */}
        <OutLinedButton
          variant={"bodySmallStrong"}
          label="Declarations"
          sx={{
            width: "150px",
            height: "45px",
            textTransform: "none",
            border: "1px solid var(--brand-600)",
            borderRadius: "8px",
          }}
          onClick={() => setOpenDeclaration(true)}
        />

        {/* Right Side Buttons */}
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <OutLinedButton
            variant={"bodySmallStrong"}
            label="Close"
            onClick={() => {
              // localStorage.removeItem("exporterMasterId"); // ✅ clear when back is clicked
              localStorage.removeItem("filterData");
              navigate(navurl.Dashboard);
            }}
            sx={{
              fontSize: "13px",
              width: "120px",
              height: "40px",
              fontWeight: 600,
              textTransform: "none",
              border: "1px solid var(--brand-600)",
              borderRadius: "8px",
            }}
          />

          <BlackButton
            key={trigger}
            label={saveLoading ? "Saving..." : "Save"}
            sx={{
              width: "120px",
              height: "40px",
              fontSize: "13px",
              fontWeight: 500,
              textTransform: "none",
              boxShadow: "none",
              backgroundColor: "var(--brand-600)",
              color: "var(--gray-0)",
              border: "none",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "var(--brand-600)",
                boxshadow: "none",
              },
              mb: 0,
            }}
            onClick={!saveLoading && handleSave}
            disabled={
              !isRequiredFieldFilled ||
              saveLoading ||
              currentTab?.type === "table"
            }
          />
        </Box>
      </Box>

      <SuccessDialog
        open={showSuccessDialog}
        onClose={() => {
          setShowSuccessDialog(false);
        }}
        {...successDialogConfig}
      />
      <ConfirmDialog
        open={confirmationConfig?.open}
        onClose={() =>
          setConfirmationConfig((prev) => ({ ...prev, open: false }))
        }
        {...confirmationConfig}
      />

      {showForm && (
        <FormDialog
          compKey={tablecompKey}
          title={
            isEditing
              ? `Edit ${currentTab?.label ?? schema.label}`
              : `Add ${currentTab?.label ?? schema.label}`
          }
          schema={schema?.schema ?? currentTab.schema ?? tableSchema[0]}
          initialData={formDialogData}
          isEditing={isEditing}
          onSubmit={() => handleSave(activeTableId ?? "table")}
          handleActions={handleActions}
          onClose={handleCloseForm}
          showCancelButton={true}
          showSubmitButton={true}
          cancelLabel="Cancel"
          submitLabel={isEditing ? "Save" : "Add"}
          loading={loading}
          ref={formRef}
          disabled={!isRequiredFieldFilled}
        />
      )}
      {openDeclaration && (
        <Dialog
          open={openDeclaration}
          onClose={() => setOpenDeclaration(false)}
          fullWidth
          maxWidth="md"
        >
          <Declaration onClose={() => setOpenDeclaration(false)} />
        </Dialog>
      )}
      {subDialogConfig && (
        <Dialog
          open={subDialogOpen}
          onClose={() => setSubDialogOpen(false)}
          fullWidth
          maxWidth="md"
        >
          <subDialogConfig.Component
            {...subDialogConfig.props}
            onClose={() => setSubDialogOpen(false)}
          />
        </Dialog>
      )}

      {openComponent &&
        (() => {
          const DynamicComponent =
            dynamicComponentMap[openComponent.component ?? openComponent];
          if (!DynamicComponent) return null;

          return (
            <DynamicComponent
              open={Boolean(anchorEl1)}
              anchorEl={anchorEl1}
              onClose={functionMap.handleClose}
              setShowSuccessDialog={setShowSuccessDialog}
              setSuccessDialogConfig={setSuccessDialogConfig}
              {...openComponent.props}
            />
          );
        })()}
    </Box>
  );
};

export default React.memo(CreateNewJob);
